import { useStore } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useFlags } from 'launchdarkly-react-client-sdk';

const useOperationFlags = () => {
  const {
    feApplicationsModuleEnableModule,
    feApplicationsEnableModuleByOrg,
    feWorkOrdersModuleEnableModule,
    feWorkOrdersEnableModuleByOrg
  } = useFlags();

  const { state } = useStore();
  const { id } = state?.organization || {};

  return {
    feApplicationsActive: featureFlagRenderItem(
      feApplicationsModuleEnableModule,
      feApplicationsEnableModuleByOrg,
      id
    ),
    feWorkOrdersActive: featureFlagRenderItem(
      feWorkOrdersModuleEnableModule,
      feWorkOrdersEnableModuleByOrg,
      id
    )
  };
};

export default useOperationFlags;
